export default "__VITE_ASSET__D4gc_U1b__"